import classNames from "classnames";

interface IAvisButtonBoxProps {
  className?: string;
  children?: React.ReactNode;
}
export function AvisButtonBox(props: Readonly<IAvisButtonBoxProps>) {
  const { children, className } = props;
  const classNameButtonBox = classNames("avis-button-box", className);

  return <div className={classNameButtonBox}>{children}</div>;
}
